import React from 'react';
import styles from './RestoreActivity.module.scss';
import { useDispatch } from 'react-redux';
import {
  SettingsInlineButton,
  Section,
  SettingsSectionBox,
  SettingsSectionLabel,
} from '@views/Settings/components';
import { restoreAllActivityItems } from '@repo/redux/actions/activity';

export default function RestoreActivity() {
  const dispatch = useDispatch();

  return (
    <Section>
      <SettingsSectionLabel>Activity View</SettingsSectionLabel>
      <SettingsSectionBox className={styles.container}>
        <div className={styles.title}>Restore all Activity items</div>
        <SettingsInlineButton onClick={() => dispatch(restoreAllActivityItems())}>
          Restore Activity
        </SettingsInlineButton>
        <p>
          Bring back all those precious memories that you heartlessly dismissed in a fit of rage.
        </p>
      </SettingsSectionBox>
    </Section>
  );
}
